// extracted by mini-css-extract-plugin
module.exports = {"container":"_3a23254b","pagetitle":"_5d2b00e7","infocontainer":"fa08ebb5","infotext":"a9091ed5","sectiontitle":"a895d8f6","sectiontext":"f31aba40"};